import { LoadingSpinner } from "@rothoblaas/design-system";
import type { FC } from "react";
import useI18n from "../../../hooks/useTranslations";

type OptionsStatusProps = {
  isLoading: boolean;
  hasError: boolean;
  // The card's own option class, so the status takes an option's place in its grid.
  className: string;
};

// Shown instead of a card's option buttons while they load, or when loading them failed.
const OptionsStatus: FC<OptionsStatusProps> = ({ isLoading, hasError, className }) => {
  const i18n = useI18n();

  if (!isLoading && !hasError) {
    return null;
  }

  return <div className={className}>{hasError ? i18n.translation.common.errorLoadingData : <LoadingSpinner />}</div>;
};

export default OptionsStatus;
